// TODO: move this to helpers/conversions?
export function convertStringToNumber(stringValue = ''): number {
  return Number(stringValue);
}
